import React, { useMemo, useState } from 'react'
import { Popup } from 'src/components'
import { useStyles } from './styles'
import { useFormContext } from 'react-hook-form'
import { HealthControlForm } from 'src/@types/validations/Animal'
import { useDebounce } from 'src/hooks/useDebounce'
import { VaccineDto } from 'src/dto/vaccine.dto'
import VaccineTabs from '../VaccineTabs'

interface SelectedVacineModalProps {
  vacineList: VaccineDto[]
  isOpen: boolean
  setIsOpenSelectedVacineModal: (isOpen: boolean) => void
}

export const SelectedVacineModal: React.FC<SelectedVacineModalProps> = ({
  isOpen,
  vacineList,
  setIsOpenSelectedVacineModal
}) => {
  const styles = useStyles()

  const { watch, setValue } = useFormContext<HealthControlForm>()

  const [search, setSearch] = useState('')

  const debouncedSearch = useDebounce(search, 400)

  const selectedVacines = watch('vacinas') || []

  const vaccines: VaccineDto[] = vacineList || []

  const filteredVacines = useMemo(() => {
    if (!debouncedSearch) return vaccines

    const value = debouncedSearch.toLowerCase()

    return vaccines.filter((vacine) => {
      return vacine.data.tipo?.toLowerCase().includes(value) || vacine.data.descricao?.toLowerCase().includes(value)
    })
  }, [vaccines, debouncedSearch])

  const handleSelectVacine = (id: string) => {
    const current = selectedVacines

    if (current.includes(id)) {
      setValue(
        'vacinas',
        current.filter((item) => item !== id)
      )
    } else {
      setValue('vacinas', [...current, id])
    }
  }

  return (
    <Popup title='Vacinas Selecionadas' isOpen={isOpen} onClose={() => setIsOpenSelectedVacineModal(false)}>
      <div className={styles.modalContent}>
        <div>
          <VaccineTabs
            search={search}
            setSearch={setSearch}
            vaccines={filteredVacines}
            selectedVacines={selectedVacines}
            onSelect={handleSelectVacine}
          />
        </div>
      </div>
    </Popup>
  )
}
